import { AppConfig, UserSession, showConnect } from '@stacks/connect';
import { StacksMainnet, StacksTestnet } from '@stacks/network';
import { clientNetwork, deruptPfp, devPrincipal, interfaceExtensionsFileName, stacksApi, userExtensionsFileName } from '../lib/constants';
import axios from 'axios';
import { Storage } from '@stacks/storage';

const appConfig = new AppConfig(["store_write", "publish_data"]);
export const userSession = new UserSession({ appConfig });

//export const network = new StacksTestnet({ url: 'https://api.nakamoto.testnet.hiro.so' });
//export const network = new StacksMainnet({ url: 'https://api.mainnet.hiro.so' });

export const network = ({ network }) => {
  return {
    testnet: new StacksTestnet({ url: 'https://api.testnet.hiro.so' }),
    mainnet: new StacksMainnet({ url: 'https://api.hiro.so' })
  }[network];
};

export function getUserData() {
  if (userSession.isUserSignedIn()) {
    return userSession.loadUserData();
  }
  return null;
}


export function authenticatedUserAddress({ network }) {
  return getUserData()?.profile?.stxAddress[network] || null;
}

export const authOptions = {
  appDetails: {
    name: 'Derupt',
    icon: window.location.origin + '/favicon.png',
  },
  redirectTo: '/home',
  onFinish: async () => {
    const storage = new Storage({ userSession });
    const authedUser = authenticatedUserAddress({ network: clientNetwork });
    try { await storage.getFile(userExtensionsFileName, { decrypt: false, verify: false }); } catch (e) {
      if (e?.code === "does_not_exist") {
        try { await storage.putFile(userExtensionsFileName, JSON.stringify([]), { encrypt: false, verify: false }); }
        catch (er) { if (er?.code === "precondition_failed_error") console.log("All good"); }
      }
    }

    try { await storage.getFile(deruptPfp, { decrypt: false, verify: false }); } catch (e) {
      if (e?.code === "does_not_exist") {
        try { await storage.putFile(deruptPfp, JSON.stringify({}), { encrypt: false, verify: false }); }
        catch (er) { if (er?.code === "precondition_failed_error") console.log("All good"); }
      }
    }

    if (authedUser === devPrincipal) {
      try { await storage.getFile(interfaceExtensionsFileName, { decrypt: false, verify: false }); } catch (e) {
        if (e?.code === "does_not_exist") {
          try { await storage.putFile(interfaceExtensionsFileName, JSON.stringify([]), { encrypt: false, verify: false }); }
          catch (er) { if (er?.code === "precondition_failed_error") console.log("All good"); }
        }
      }
    }
    window.location.reload();
  },
  userSession: userSession,
};

export function authenticate() {
  showConnect(authOptions);
}

export function logout() {
  userSession.signUserOut(window.location.origin);
}

export async function userBalance({ token_asset_id }) {
  const userAddress = authenticatedUserAddress({ network: clientNetwork });
  const userBalance = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${userAddress}/balances`)).data;
  return { stx: parseInt(userBalance['stx'].balance) || 0, [token_asset_id]: userBalance['fungible_tokens'][token_asset_id]?.balance || 0 }
}

export function isUserSignedIn() {
  return userSession.isUserSignedIn();
}